import type { CSSProperties } from 'react';
import loopLogoPng from '@/assets/loop-logo.png';

export interface LoopLogoProps {
  height?: number | string;
  className?: string;
  style?: CSSProperties;
  ariaLabel?: string;
}

const LoopLogo = ({
  height = 32,
  className,
  style,
  ariaLabel = 'הגמ"ח המרכזי',
}: LoopLogoProps) => {
  const h = typeof height === 'number' ? `${height}px` : height;
  return (
    <img
      src={loopLogoPng}
      alt={ariaLabel}
      className={className}
      style={{
        height: h,
        width: 'auto',
        display: 'block',
        objectFit: 'contain',
        ...style,
      }}
    />
  );
};

export default LoopLogo;
